import { render } from "./NavigationTab.vue?vue&type=template&id=0c40f3d5&scoped=true&ts=true"
import script from "./NavigationTab.vue?vue&type=script&lang=ts"
export * from "./NavigationTab.vue?vue&type=script&lang=ts"

import "./NavigationTab.vue?vue&type=style&index=0&id=0c40f3d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c40f3d5"]])

export default __exports__